import { SELECT_LOOKUP, DATE, HIDDEN } from '../InputTypes';

export const fields = [
  'CertificateTypeName',
  'CertificateName',
  'CertificatePeriodBegda',
  'CertificatePeriodEnda',
];

export const detailFields = [
  ...fields,
];

export const entityMap = {
  EmployeeMasterID: {
    type: HIDDEN,
  },
  CertificateType: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrCertificateType?$filter=Disabled eq false',
      value: 'HrCertificateTypeID',
      label: 'HrCertificateTypeName',
    },
  },
  HrCertificateID: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrCertificate?$filter=Disabled eq false',
      link: 'HrCertificateType',
      lookupValue: 'CertificateType',
      value: 'HrCertificateID',
      label: 'HrCertificateName',
      number: true,
    },
  },
  EmployeeMasterCertificateID: {
    type: HIDDEN,
  },
  CertificatePeriodBegda: {
    type: DATE,
  },
  CertificatePeriodEnda: {
    type: DATE,
  },
};



// WEBPACK FOOTER //
// ./src/constants/fields/EmployeeMasterCertificate.js